module.exports = __webpack_public_path__ + "img/window.0d8c21f0.png";